export const version = '__VERSION__';

export * from './compoundStrategy';
